import { BetslipUpsellData } from '@cds/betting-offer/domain-specific/betslip-upsell';
import { EventModel, EventOption, EventOptionGroup, EventParticipant } from '@frontend/sports/betting-offer/feature/model';

import { BetslipPick } from '../../core/picks/betslip-pick';

export interface PickGridGroupSport {
    sportId: number;
    gridGroupId?: string;
    startsAt: string;
    isLive: boolean;
    fixtureId: string;
    isLocked: boolean;
    sourceOfPick?: string;
}

export interface UpsellData {
    events: UpsellEventData[];
    gridGroupId?: string;
}

export interface UpsellEventData {
    event: EventModel;
    upsellData: BetslipUpsellData;
}

export interface UpsellEvent {
    event: EventModel;
    bestSellingOption: EventOption;
    bestSellingOptionGroup: EventOptionGroup;
    bestSellingPick: BetslipPick;
    winningMarket: string;
    eventParticipant?: EventParticipant;
    showParticipantImage: boolean;
    isSelected: boolean;
    taxAmount?: number; // Amount received from TaxService or undefined if TaxService isn't called
}

export enum TranslationMapping {
    ToWin = 'towin',
    MoneyLine = 'moneyline',
    OverUnder = 'overunder',
    DoubleChance = 'doublechance',

    BTTS = 'btts',
    Spread = 'spread',
    Totals = 'totals',
}
